/* Shared Build, single-build mode: /pages/shared-build?code=B-330-75-1-1A
   ----------------------------------------------------------------------
   The ?items= mode on this page (assets/shared-build.js) is a shared CART -
   a list of real variants someone already configured, replayed read-only
   apart from quantity. This is the other half Dave asked for: a link that
   carries ONE build as a code, opens it unlocked so the person who received
   it can change the length, the force and both end fittings, re-share what
   they ended up with, and - when the build is a length we stock - buy it
   themselves at the catalogue price, in whatever quantity they need.

   Two rules this file exists to keep:

   1. No price ever comes off the URL. The only price shown or charged is the
      variant price emitted server-side into window.SB_DATA by the template,
      and the /cart/add.js call sends {id, quantity, properties} only - Shopify
      prices the line from the variant. A build we do NOT stock has no price
      here at all; it goes to the request form instead. Per-link pricing would
      need a Shopify draft order, which is Dave's call, not this page's.

   2. Re-sharing an untouched link gives back the same link. The code is
      regenerated from live state, and parse -> state -> build is lossless, so
      opening B-330-75-1-1A and hitting Share without touching anything hands
      back B-330-75-1-1A. */
(function(){
  var SC = window.StruxaStrutCode;
  if(!SC) return;

  var FORMSPREE_URL = 'https://formspree.io/f/maqgbndr';
  var CONTACT_EMAIL = 'info@struxamotion.com';
  var LEN_MIN = 250, LEN_MAX = 700;
  var FORCE_MIN = 100, FORCE_MAX = 750, FORCE_STEP = 10;

  var S = null;   /* live build state */
  var match = null;

  function el(id){ return document.getElementById(id); }
  function money(cents){
    if(cents === null || cents === undefined) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  /* Same rule as everywhere else on the store: Shopify applies ONE automatic
     discount, the best one, and Elite is the single tier where bulk stacks.
     Mirrors discountFor() in assets/shared-build.js. */
  function tradePct(){ return (window.SX_TRADE && +window.SX_TRADE.pct) || 0; }
  function isElite(){ return !!(window.SX_TRADE && window.SX_TRADE.elite); }
  function bulkQty(){ return (window.SX_BULK && +window.SX_BULK.qty) || 10; }
  function bulkPct(){ return (window.SX_BULK && +window.SX_BULK.percent) || 10; }
  function discountFor(totalQty){
    var trade = tradePct();
    var atBulk = totalQty >= bulkQty();
    if(atBulk && isElite()) return { pct: trade + 5, why: 'Elite bulk discount' };
    var bulk = atBulk ? bulkPct() : 0;
    if(trade >= bulk) return { pct: trade, why: trade ? 'trade discount' : '' };
    return { pct: bulk, why: bulkQty() + '+ bulk discount' };
  }

  /* navigator.share needs transient user activation and iOS rejects it after
     any await, so the sharer's referral code is warmed once up front and read
     from this cache at click time. A share fired before the lookup lands goes
     out as a plain link, which is what it was before referral codes existed. */
  var REF_CODE = null;
  function warmRefCode(){
    if(REF_CODE !== null) return;
    REF_CODE = '';
    if(!(window.StruxaShare && window.StruxaShare.getOwnReferralCode)) return;
    window.StruxaShare.getOwnReferralCode().then(function(c){ REF_CODE = c || ''; }, function(){ REF_CODE = ''; });
  }
  function refShareUrl(url){
    if(!REF_CODE || window.SX_REF_SHARE_OPTOUT) return url;
    if(!(window.StruxaShare && window.StruxaShare.withReferralCode)) return url;
    return window.StruxaShare.withReferralCode(url, REF_CODE);
  }

  function currentCode(){
    return SC.buildCode(S.diam, S.len, S.force, S.shaftFit, S.shaftBall, S.bodyFit, S.bodyBall);
  }

  /* Regenerated from the CURRENT state every time, never from the URL that was
     opened - that is what makes an edited build shareable. Quantity only rides
     along when it is not 1, so an untouched link round-trips byte for byte. */
  function currentShareUrl(){
    var code = currentCode();
    if(!code) return null;
    var url = window.location.origin + '/pages/shared-build?code=' + encodeURIComponent(code);
    if(S.qty > 1) url += '&qty=' + S.qty;
    return url;
  }

  // Same shape as fullStrutName() in assets/gas-struts-catalogue.js and
  // stxCartProps() in snippets/sx-label-scanner.liquid. Matches the Shopify
  // product title "Gas Strut - 8mm Shaft"; the old form led on the shaft
  // diameter unlabelled, which reads as a length. Asserted in
  // tools/cart-props.test.js so the three cannot drift apart.
  function buildTitle(){
    return 'Gas Strut - ' + S.diam + 'mm Shaft, ' + S.len + 'mm, ' + S.force + 'N';
  }

  /* A build maps to something we stock when the shaft diameter and the exact
     installation length are both a variant of the 8mm Gas Strut product. Force
     is not part of the match: we set the force when we build the strut, so any
     force on a stocked length is the same stocked SKU at the same price - that
     is exactly how the catalogue card behaves. */
  function findStock(){
    var sizes = (window.SB_DATA && window.SB_DATA.strutSizes) || [];
    var found = null;
    sizes.forEach(function(sz){
      if(found) return;
      if(sz.diam === S.diam && sz.len === S.len) found = sz;
    });
    return found;
  }

  function lineItemProperties(){
    var props = {
      '_Full Name': buildTitle(),
      'Length (mm)': String(S.len),
      // Private: hidden from the buyer, kept on the order. See sx-physics.
      '_Pressure (N)': String(S.force),
      'Shaft End': SC.fitName(S.shaftFit),
      'Body / Tube End': SC.fitName(S.bodyFit),
      'End Fittings': SC.buildFitLabel(S.shaftFit, S.shaftBall, S.bodyFit, S.bodyBall),
      'Code': currentCode() || 'Contact us to confirm'
    };
    if(S.shaftBall) props['Ball stud (shaft end)'] = 'Yes';
    if(S.bodyBall) props['Ball stud (body / tube end)'] = 'Yes';
    return props;
  }

  /* ---------------------------------------------------------------- render */

  function refresh(){
    var code = currentCode();

    el('sbbImg').src = SC.compositeUrl(S.shaftFit, S.bodyFit, S.shaftBall, S.bodyBall);
    el('sbbImg').alt = buildTitle();
    el('sbbLenPill').textContent = S.len + ' mm';
    el('sbbCode').textContent = code || 'Contact us to confirm';
    el('sbbForceConv').textContent = SC.forceToLbs(S.force) + ' lbs · ' + SC.forceToKg(S.force) + ' kg';
    el('sbbSpecs').textContent =
      S.diam + 'mm shaft · ' + S.len + 'mm installation length · ' + S.force + 'N · ' +
      SC.buildFitLabel(S.shaftFit, S.shaftBall, S.bodyFit, S.bodyBall);

    syncBallBox('sbbShaftBall', S.shaftFit);
    syncBallBox('sbbBodyBall', S.bodyFit);

    match = findStock();
    var stockEl = el('sbbStock');
    var buyBlock = el('sbbBuyBlock');
    var requestBlock = el('sbbRequestBlock');

    if(match && match.qty > 0){
      var unit = match.price;
      var gross = unit * S.qty;
      var d = discountFor(S.qty);
      var priceHtml = '<span class="sbb-unit">' + money(unit) + ' each (incl. GST)</span>';
      if(S.qty > 1 || d.pct > 0){
        if(d.pct > 0){
          priceHtml += '<span class="sbb-total"><s>' + money(gross) + '</s> ' +
            money(Math.round(gross * (1 - d.pct / 100))) + '</span>' +
            '<span class="sbb-disc">' + d.pct + '% ' + d.why + ' applied at checkout</span>';
        } else {
          priceHtml += '<span class="sbb-total">' + money(gross) + ' total</span>';
        }
      }
      stockEl.className = 'sbb-stock in';
      stockEl.innerHTML = '<div class="sbb-badge">In stock - ' + S.len + 'mm, built to ' + S.force + 'N</div>' + priceHtml;
      buyBlock.style.display = 'block';
      requestBlock.style.display = 'none';
      el('sbbBuy').textContent = S.qty > 1 ? ('Add ' + S.qty + ' to Cart') : 'Add to Cart';
    } else {
      /* Not a length we stock (or stocked but sold out). No price is invented
         here and none is accepted from the link - this build is quote-only
         until Dave confirms it, exactly as the scanner's builder does. */
      var why = match
        ? 'We stock ' + S.len + 'mm but it is sold out right now.'
        : 'We do not stock ' + S.len + 'mm - this is a made-to-order length.';
      stockEl.className = 'sbb-stock out';
      // Two different things share this branch. A length we stock that is
      // simply out comes back; an arbitrary length never will. Telling
      // someone who asked for 333mm to wait for stock would be a lie, so
      // only the sold-out case gets the notify wording.
      stockEl.innerHTML = '<div class="sbb-badge">'
        + (match ? 'Notify when in stock' : 'Made to order') + '</div>' +
        '<span class="sbb-unit">' + why + ' Send it through and we will confirm price and lead time.</span>';
      buyBlock.style.display = 'none';
      requestBlock.style.display = 'block';
    }
  }

  /* A fitting with no ball-stud version cannot have the box ticked. */
  function syncBallBox(boxId, fitId){
    var box = el(boxId);
    var f = SC.FIT_MAP[fitId];
    var ok = !!(f && f.studCompatible);
    box.disabled = !ok;
    if(!ok) box.checked = false;
    var lbl = box.parentNode;
    if(lbl) lbl.className = ok ? 'sbb-cb' : 'sbb-cb is-off';
  }

  function fillSelect(select, current){
    SC.FIT_CHOICES.forEach(function(f){
      var o = document.createElement('option');
      o.value = f.id; o.textContent = f.name;
      select.appendChild(o);
    });
    /* A withdrawn fitting still resolves from an older code, so give it an
       option of its own rather than silently snapping the build to something
       the sender did not choose. */
    if(current && !select.querySelector('option[value="' + current + '"]')){
      var o2 = document.createElement('option');
      o2.value = current;
      o2.textContent = SC.fitName(current) + ' (withdrawn)';
      select.appendChild(o2);
    }
    select.value = current;
  }

  function fitDesc(select, descEl){
    function paint(){
      var f = SC.FIT_MAP[select.value];
      descEl.textContent = f ? f.desc : '';
    }
    select.addEventListener('change', paint);
    paint();
  }

  /* ------------------------------------------------------------------ buy */

  function addToCart(){
    var btn = el('sbbBuy');
    var msg = el('sbbMsg');
    if(!match || !match.variantId) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    msg.style.display = 'none';
    var item = { id: match.variantId, quantity: S.qty, properties: lineItemProperties() };
    window.StruxaShare.addAllToCart([item], function(err){
      btn.disabled = false;
      btn.textContent = orig;
      if(err){
        msg.style.display = 'block';
        msg.style.color = '#c0392b';
        msg.textContent = err.message || 'Something went wrong adding this to your cart.';
      } else {
        window.location.href = '/cart';
      }
    });
  }

  /* ---------------------------------------------------------------- share */

  /* Matches shareLink() in assets/gas-struts-catalogue.js and sxShareProduct in
     assets/sx-vehicle-finder-nz.js: navigator.share called SYNCHRONOUSLY inside
     the click when it exists, the confirmed state painted immediately rather
     than after the clipboard resolves, AbortError (the customer closing the
     sheet) swallowed, and the button only walked back on a real failure. */
  function shareCurrent(){
    var btn = el('sbbShare');
    var url = currentShareUrl();
    if(!url) return;
    var title = buildTitle();

    function mark(ok){
      btn.textContent = ok ? 'Link copied!' : 'Could not copy - try again';
      btn.classList.toggle('is-error', !ok);
      if(btn.__sbT) clearTimeout(btn.__sbT);
      btn.__sbT = setTimeout(function(){
        btn.textContent = 'Share This Build';
        btn.classList.remove('is-error');
      }, 1800);
    }
    function copyFallback(){
      mark(true);
      window.StruxaShare.copyToClipboard(refShareUrl(url)).catch(function(){ mark(false); });
    }
    /* No "Link copied!" on the native path - the share sheet is the feedback. */
    if(navigator.share){
      try {
        var res = navigator.share({ title: title, text: 'From Struxa: ' + title, url: refShareUrl(url) });
        if(res && res.then){ res.then(null, function(err){ if(err && err.name === 'AbortError') return; copyFallback(); }); }
        return;
      } catch(e){}
    }
    copyFallback();
  }

  /* -------------------------------------------------------------- request */

  function submitRequest(){
    var btn = el('sbbReqBtn');
    var errEl = el('sbbReqError');
    var okEl = el('sbbReqMsg');
    var email = el('sbbReqEmail').value.trim();
    errEl.style.display = 'none';
    if(!email || email.indexOf('@') === -1){
      errEl.textContent = 'Please enter a valid email so we can come back to you.';
      errEl.style.display = 'block';
      return;
    }
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Sending…';

    var fd = new FormData();
    fd.append('name', el('sbbReqName').value.trim());
    fd.append('email', email);
    fd.append('build_code', currentCode() || '');
    fd.append('shaft_diameter_mm', String(S.diam));
    fd.append('length_mm', String(S.len));
    fd.append('force_n', String(S.force));
    fd.append('shaft_fitting', SC.fitName(S.shaftFit) + (S.shaftBall ? ' + ball stud' : ''));
    fd.append('body_fitting', SC.fitName(S.bodyFit) + (S.bodyBall ? ' + ball stud' : ''));
    fd.append('quantity', String(S.qty));
    fd.append('notes', el('sbbReqNotes').value.trim());
    fd.append('shared_build_link', currentShareUrl() || '');
    fd.append('_subject', 'Struxa - Custom build request' + (currentCode() ? ' - ' + currentCode() : ''));

    fetch(FORMSPREE_URL, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function(res){
        if(!res.ok) throw new Error('send_failed');
        el('sbbReqForm').style.display = 'none';
        okEl.style.display = 'block';
      })
      .catch(function(){
        errEl.textContent = 'Could not send that - please email ' + CONTACT_EMAIL + ' directly.';
        errEl.style.display = 'block';
      })
      .finally(function(){
        btn.disabled = false;
        btn.textContent = orig;
      });
  }

  /* ----------------------------------------------------------------- wire */

  function clampLen(v){
    if(!v || v < LEN_MIN) return LEN_MIN;
    if(v > LEN_MAX) return LEN_MAX;
    return v;
  }
  function clampForce(v){
    if(!v || v < FORCE_MIN) return FORCE_MIN;
    if(v > FORCE_MAX) return FORCE_MAX;
    return Math.round(v / FORCE_STEP) * FORCE_STEP;
  }

  function wire(){
    var lenInput = el('sbbLength');
    var forceNum = el('sbbForce');
    var forceSlider = el('sbbForceSlider');
    var shaftSel = el('sbbShaft');
    var bodySel = el('sbbBody');
    var shaftBall = el('sbbShaftBall');
    var bodyBall = el('sbbBodyBall');
    var qtyInput = el('sbbQty');

    fillSelect(shaftSel, S.shaftFit);
    fillSelect(bodySel, S.bodyFit);
    fitDesc(shaftSel, el('sbbShaftDesc'));
    fitDesc(bodySel, el('sbbBodyDesc'));
    el('sbbStudNote').textContent = SC.BALL_STUD_NOTE;

    /* The incoming build can sit outside the range we offer on a fresh build
       (an older or a bespoke code), so the value is only clamped once the
       viewer edits it - opening a link never silently rewrites the build. */
    lenInput.value = S.len;
    forceNum.value = S.force;
    forceSlider.value = Math.min(FORCE_MAX, Math.max(FORCE_MIN, S.force));
    qtyInput.value = S.qty;

    lenInput.addEventListener('change', function(){
      S.len = clampLen(parseInt(lenInput.value, 10));
      lenInput.value = S.len;
      refresh();
    });
    forceNum.addEventListener('change', function(){
      S.force = clampForce(parseInt(forceNum.value, 10));
      forceNum.value = S.force;
      forceSlider.value = S.force;
      refresh();
    });
    forceSlider.addEventListener('input', function(){
      S.force = clampForce(parseInt(forceSlider.value, 10));
      forceNum.value = S.force;
      refresh();
    });
    shaftSel.addEventListener('change', function(){
      S.shaftFit = shaftSel.value;
      S.shaftBall = S.shaftBall && !!SC.FIT_MAP[S.shaftFit].studCompatible;
      shaftBall.checked = S.shaftBall;
      refresh();
    });
    bodySel.addEventListener('change', function(){
      S.bodyFit = bodySel.value;
      S.bodyBall = S.bodyBall && !!SC.FIT_MAP[S.bodyFit].studCompatible;
      bodyBall.checked = S.bodyBall;
      refresh();
    });
    shaftBall.addEventListener('change', function(){ S.shaftBall = shaftBall.checked; refresh(); });
    bodyBall.addEventListener('change', function(){ S.bodyBall = bodyBall.checked; refresh(); });
    qtyInput.addEventListener('change', function(){
      var v = parseInt(qtyInput.value, 10);
      if(!v || v < 1) v = 1;
      qtyInput.value = v;
      S.qty = v;
      refresh();
    });

    shaftBall.checked = S.shaftBall;
    bodyBall.checked = S.bodyBall;

    el('sbbBuy').addEventListener('click', addToCart);
    el('sbbShare').addEventListener('click', shareCurrent);
    el('sbbReqBtn').addEventListener('click', submitRequest);
  }

  /* An ?items= link carrying a single strut already has its build code in the
     line item properties, so it can hand straight over to this editor rather
     than being a dead end. */
  function offerEditFromItems(){
    if(!(window.StruxaShare && window.StruxaShare.decodeItemsFromUrl)) return;
    var items = window.StruxaShare.decodeItemsFromUrl();
    if(!items || items.length !== 1) return;
    var parsed = SC.parseCode(items[0].properties && items[0].properties.Code);
    if(!parsed) return;
    var host = el('sbEditFromItems');
    if(!host) return;
    var code = SC.buildCode(parsed.diam, parsed.len, parsed.force, parsed.shaftFit, parsed.shaftBall, parsed.bodyFit, parsed.bodyBall);
    if(!code) return;
    var qty = items[0].quantity > 1 ? '&qty=' + items[0].quantity : '';
    host.innerHTML = '<a href="/pages/shared-build?code=' + encodeURIComponent(code) + qty + '">Edit this build →</a>';
    host.style.display = 'block';
  }

  function start(){
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    if(!code){
      offerEditFromItems();
      return;
    }
    var parsed = SC.parseCode(code);
    if(!parsed){
      var empty = el('sbEmpty');
      if(empty) empty.style.display = 'block';
      return;
    }
    var qty = parseInt(params.get('qty'), 10);
    S = {
      diam: parsed.diam, len: parsed.len, force: parsed.force,
      shaftFit: parsed.shaftFit, shaftBall: parsed.shaftBall,
      bodyFit: parsed.bodyFit, bodyBall: parsed.bodyBall,
      qty: (qty && qty > 0) ? qty : 1
    };
    var root = el('sbRoot');
    if(root) root.style.display = 'none';
    el('sbBuild').style.display = 'block';
    warmRefCode();
    wire();
    refresh();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
